import { connect } from "react-redux";

import FilterPopover from "./component";

const FilterPopoverContainer = connect(() => ({}), {})(FilterPopover);

export default FilterPopoverContainer;
